import { Transform, Expose, Exclude } from 'class-transformer';
import { DocumentSnapshot } from 'firebase/firestore';
import { _FirebaseDocument, anyToDate } from './Models';

@Exclude()
export class Maintenance extends _FirebaseDocument {
    @Expose()
    public enabled: boolean;

    @Expose()
    public message?: string;

    @Expose()
    @Transform(anyToDate)
    public estimated_end?: Date;

    collection(): string {
        return "system";
    }

    static fromFirebase(o: DocumentSnapshot): Maintenance | null {
        return _FirebaseDocument._fromFirebase(Maintenance, o);
    }
}

